import { render, staticRenderFns } from "./ConfirmBooking.vue?vue&type=template&id=1924807a&scoped=true"
import script from "./ConfirmBooking.vue?vue&type=script&lang=js"
export * from "./ConfirmBooking.vue?vue&type=script&lang=js"
import style0 from "./ConfirmBooking.vue?vue&type=style&index=0&id=1924807a&prod&lang=css"
import style1 from "./ConfirmBooking.vue?vue&type=style&index=1&id=1924807a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1924807a",
  null
  
)

export default component.exports